import React from "react";
import {InstallationElement} from "../../../models/operations/InstallationElement";
import {ProcessStep} from "../../../models/ProcessStep";
import {EElementType} from "../../../models/utils/EElementType";
import ElementService from "../../ElementService";
import SelectElementTypeStep from "../../../components/steps/select/SelectElementTypeStep";
import {AElement} from "../../../models/elements/AElement";
import StepsAccordingToSpecificationsService from "../StepsAccordingToSpecificationsService";
import {Unknown} from "../../../models/elements/Unknown";

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 17/05/2022
 * @last_update 17/05/2022
 **/
class ElementInstallationSteps {

    public getElementInstallationSteps(operation: InstallationElement, setOperation: (operation: InstallationElement) => void): ProcessStep[] {
        let steps: ProcessStep[] = [];
        steps = steps.concat(this.getEquipmentIdentificationStep(operation, setOperation));
        steps.push(this.getSelectElementTypeStep(operation, setOperation));
        steps = steps.concat(this.getElementIdentificationStep(operation, setOperation));
        return steps;
    }
    
    private getElementIdentificationStep(operation: InstallationElement, setOperation: (operation: InstallationElement) => void): ProcessStep[] {
        const steps: ProcessStep[] = [];
        const element = operation.newElement;
        const setElement = (element: AElement) => {
            operation.newElement = element;
            setOperation(operation);
        }
        if(element) {
            steps.push(StepsAccordingToSpecificationsService.getIdentificationStep(element.type, setElement, element));
        }
        return steps;
    }

    private getEquipmentIdentificationStep(operation: InstallationElement, setOperation: (operation: InstallationElement) => void): ProcessStep[] {
        const steps: ProcessStep[] = [];
        const equipment = new Unknown(operation.equipmentId !== undefined ? operation.equipmentId : '');
        const setElement = (element: AElement) => {
            operation.equipmentId = element.serialNumber;
            setOperation(operation);
        }
        steps.push(StepsAccordingToSpecificationsService.getIdentificationStep(EElementType.Unknown, setElement, equipment));
        return steps;
    }

    private getSelectElementTypeStep(operation: InstallationElement, setOperation: (operation: InstallationElement) => void): ProcessStep {
        const setElementType = (elementType: EElementType) => {
            if(operation.newElement === undefined || operation.newElement.type !== elementType) {
                operation.newElement = ElementService.createsElementAccordingToType(elementType);
                setOperation(operation);
            }
        }
        return new ProcessStep("steps.titles.add-element", this.getSelectElementTypeComponent(setElementType, operation.newElement?.type));
    }

    private getSelectElementTypeComponent(setElementType: (elementType: EElementType) => void, elementType?: EElementType) {
        return <SelectElementTypeStep initialElementType={elementType} onValidate={setElementType}/>
    }

}

export default new ElementInstallationSteps();
